import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";

const wins = [
  {
    number: "01",
    description:
      "Grew Interlock from concept to 650,000+ daily active users, securing $100M+ in digital assets",
    href: "/case-studies/interlock",
  },
  {
    number: "02",
    description:
      "Built and exited Apozy (Y-Combinator backed). Technology adopted by Coinbase, Gemini, Uber. $5M raised",
    href: "/case-studies/apozy",
  },
  {
    number: "03",
    description:
      "Scaled Radwood to 70% profitability, then acquired by Hagerty",
    href: "/case-studies/radwood",
  },
  {
    number: "04",
    description:
      "Built AI content engines that let non-technical teams move 10X faster",
    href: "/case-studies/velocity-markets",
  },
  {
    number: "05",
    description:
      "Built a privacy-first wellness platform processing real-time wearable data at scale",
    href: "/case-studies",
  },
  {
    number: "06",
    description:
      "DEFCON speaker, CCSS Auditor, pen-testing veteran. Security is baked in, not bolted on",
    href: "/case-studies/security-career",
  },
];

const successItems = [
  "Validate before they build",
  "Ship fast, learn faster",
  "Treat AI as a tool, not a strategy",
  "Build security in from day one",
  "Focus on one thing until it works",
];

const failureItems = [
  "Build for 12 months before talking to a customer",
  "Chase every AI trend",
  "Ignore security until it's a crisis",
  "Hire a dev shop instead of a builder",
  "Confuse activity with progress",
];

export default function ProofAndPatterns() {
  return (
    <section id="proof-and-patterns" aria-label="Proof and Patterns" className="editorial-container section-spacing">
      <hr className="editorial-rule mb-16 lg:mb-20" />

      {/* Label */}
      <ScrollReveal>
        <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
          PROOF &amp; PATTERNS
        </p>
      </ScrollReveal>

      {/* Headline */}
      <ScrollReveal stagger={1}>
        <h2 className="mt-6 font-display text-section font-bold text-foreground md:text-section-md lg:text-section-lg">
          Selected Wins
        </h2>
      </ScrollReveal>

      {/* Wins list */}
      <div className="mt-12">
        {wins.map((win, i) => {
          const content = (
            <div className={`flex gap-6 border-b border-rule py-6 first:pt-0 ${win.href ? "group" : ""}`}>
              <span className="shrink-0 font-mono text-2xl text-accent md:text-3xl">
                {win.number}
              </span>
              <div>
                <p className="text-foreground-muted md:text-body-md">
                  {win.description}
                </p>
                {win.href && (
                  <span className="mt-2 inline-flex items-center gap-2 font-body text-cta uppercase text-accent opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:gap-4">
                    READ CASE STUDY <span aria-hidden="true">→</span>
                  </span>
                )}
              </div>
            </div>
          );
          return (
            <ScrollReveal
              key={win.number}
              stagger={Math.min(i + 1, 5) as 1 | 2 | 3 | 4 | 5}
            >
              {win.href ? (
                <Link to={win.href}>{content}</Link>
              ) : (
                content
              )}
            </ScrollReveal>
          );
        })}
      </div>

      {/* View all case studies */}
      <ScrollReveal className="mt-10">
        <Link
          to="/case-studies"
          className="group inline-flex items-center gap-2 font-body text-cta uppercase text-accent transition-all duration-300 hover:gap-4"
        >
          VIEW ALL CASE STUDIES
          <span aria-hidden="true" className="inline-block transition-transform duration-300 group-hover:translate-x-0.5">→</span>
        </Link>
      </ScrollReveal>

      {/* Success vs Failure comparison */}
      <ScrollReveal className="mt-20">
        <div className="grid gap-12 md:grid-cols-2 md:gap-16">
          {/* Success column */}
          <div>
            <h3 className="font-display text-subsection font-semibold text-foreground md:text-subsection-md">
              What Successful Founders Do
            </h3>
            <ul className="mt-6 space-y-3">
              {successItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span
                    aria-hidden="true"
                    className="mt-0.5 shrink-0 text-accent"
                  >
                    ✓
                  </span>
                  <span className="text-foreground-muted">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Failure column */}
          <div>
            <h3 className="font-display text-subsection font-semibold text-foreground md:text-subsection-md">
              What Struggling Founders Do
            </h3>
            <ul className="mt-6 space-y-3">
              {failureItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span
                    aria-hidden="true"
                    className="mt-0.5 shrink-0 text-foreground-faint"
                  >
                    ✗
                  </span>
                  <span className="text-foreground-faint">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </ScrollReveal>
    </section>
  );
}
